import { PairedCostFeatures } from '@aloft/toolkit-shared';

import { Tkv2OrderContext } from '../../../../controller/types.js';

export const getLabel = (context: Tkv2OrderContext, featureKey: keyof PairedCostFeatures): string =>
  context.pairedCostResults.adjustmentLabels[featureKey];
